export const RoleMap = {
    ROLE_YOUNG_DISPATCHER: 'Młodszy Dyspozytor',
    ROLE_ADULT_DISPATCHER: 'Starszy Dyspozytor',
    ROLE_DRIVER: 'Kierowca',
    ROLE_PASSENGER: 'Pasażer',
    ROLE_ADMIN: 'Administrator'
};